import { Controller } from "@hotwired/stimulus"

// Manages notification bell badge dismiss/reappear behavior.
// Badge hides when dropdown is opened (stored in localStorage).
// Badge reappears when the server-side count changes.

export default class extends Controller {
  static targets = ["badge"]
  static values = { count: Number }

  connect() {
    const dismissed = localStorage.getItem("logix-notification-dismissed-count")
    if (dismissed !== null && parseInt(dismissed, 10) === this.countValue) {
      this._hideBadge()
    }
  }

  dismiss() {
    localStorage.setItem("logix-notification-dismissed-count", this.countValue)
    this._hideBadge()
  }

  _hideBadge() {
    if (this.hasBadgeTarget) {
      this.badgeTarget.style.display = "none"
    }
  }
}
